<template>
  <div class="container wow fadeIn top-buffer">
    <div class="container my-5">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-5"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <div class="text-muted mb-3 container row">
              <div class="vld-parent">
                <loading
                  :active.sync="isLoading"
                  :can-cancel="false"
                  :is-full-page="true"
                ></loading>
              </div>
              <div class="col-mb-3">
                <p>Register as a Agent ? No/Yes &nbsp;</p>
              </div>
              <div class="col-mb-3">
                <base-switch @change="agent = !agent"></base-switch>
              </div>
            </div>
            <div v-if="!agent">
              <template>
                <div class="text-muted text-center mb-3">
                  <small>Sign in with</small>
                </div>
                <div class="btn-wrapper text-center">
                  <base-button type="danger" class="btn btn-block">
                    Google
                  </base-button>
                </div>
              </template>
            </div>
            <template>
              <div class="text-center text-muted mb-4 my-3">
                <small>Sign up with credentials</small>
              </div>
              <form role="form" enctype="multipart/form-data">
                <base-input
                  alternative
                  class="mb-3"
                  placeholder="Full Name"
                  addon-left-icon="ni ni-hat-3"
                  v-model="fullName"
                >
                </base-input>
                <base-input
                  alternative
                  class="mb-3"
                  placeholder="Email"
                  addon-left-icon="ni ni-email-83"
                  v-model="email"
                >
                </base-input>
                <base-input
                  alternative
                  type="password"
                  placeholder="Password"
                  addon-left-icon="ni ni-lock-circle-open"
                  v-model="password"
                >
                </base-input>
                <base-input
                  alternative
                  type="password"
                  placeholder="Confirm Password"
                  addon-left-icon="ni ni-lock-circle-open"
                  v-model="confirm"
                >
                </base-input>

                <div v-if="agent">
                  <div class="text-muted text-center mb-3">
                    <small class="text-muted mb-3">Agent Section</small>
                  </div>
                  <base-input
                    alternative
                    class="mb-3"
                    type="text"
                    placeholder="Phone Number"
                    addon-left-icon="ni ni-user-run"
                    v-model="mobile"
                  >
                  </base-input>
                  <label for=""
                    >Upload picture of National ID or Passport</label
                  >
                  <input
                    alternative
                    @change="onFileChanged"
                    class="mb-3"
                    type="file"
                    accept="image/*"
                    addon-left-icon="ni ni-badge"
                  />

                  <base-input class="mb-4">
                    <textarea
                      class="form-control form-control-alternative"
                      name="address"
                      rows="4"
                      cols="80"
                      placeholder="Address"
                      v-model="address"
                    ></textarea>
                  </base-input>

                  <base-input
                    alternative
                    class="mb-3"
                    type="text"
                    placeholder="Postal Code"
                    addon-left-icon="ni ni-user-run"
                    v-model="postalCode"
                  >
                  </base-input>
                  <b-form-select
                    class="mb-3"
                    placeholder="Province"
                    v-model="province"
                    :options="options"
                  ></b-form-select>
                </div>

                <base-checkbox v-model="AgreeingToTerms">
                  <span
                    >I agree with the
                    <a href="/Terms">Privacy Policy</a>
                  </span>
                </base-checkbox>
                <div class="text-center">
                  <button
                    type="button"
                    name="save"
                    @click="onUpload"
                    class="btn btn-primary my-4"
                  >
                    Create account
                  </button>
                </div>
              </form>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/settings/config.js";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import _axios from "@/services/axios";

export default {
  components: { Loading },
  data() {
    return {
      selectedFile: null,
      fullName: "",
      agent: false,
      mobile: "",
      email: "",
      password: "",
      confirm: "",
      address: "",
      postalCode: "",
      province: "Western Cape",
      AgreeingToTerms: false,
      isLoading: false,
      options: [
        { value: "Eastern Cape", text: "Eastern Cape" },
        { value: "Free State", text: "Free State" },
        { value: "Gauteng", text: "Gauteng" },
        { value: "KwaZulu-Natal", text: "KwaZulu-Natal" },
        { value: "Limpopo", text: "Limpopo" },
        { value: "Mpumalanga", text: "Mpumalanga" },
        { value: "Northern Cape", text: "Northern Cape" },
        { value: "North West", text: "North West" },
        { value: "Western Cape", text: "Western Cape" },
      ],
    };
  },
  methods: {
    onFileChanged(event) {
      this.selectedFile = event.target.files[0];
    },
    validate() {
      if (this.password == "" || this.postalCode == null) {
        this.Notify("Password cannot be set to blank!");
        return false;
      }
      if (this.password !== this.confirm) {
        this.Notify("Password and Password Confirm should be the same!");
        return false;
      }
      if (!this.AgreeingToTerms) {
        this.Notify(
          "Your need to agree to terms and conditions in order to proceed!"
        );
        return false;
      }
      return true;
    },
    onUpload() {
      if (!this.validate()) return;
      const formData = new FormData();
      this.isLoading = true;
      if (this.selectedFile != null)
        formData.append("image", this.selectedFile, this.selectedFile.name);
      formData.append("fullName", this.fullName);
      formData.append("mobile", this.mobile);
      formData.append("email", this.email);
      formData.append("password", this.password);
      formData.append("isAgent", this.agent);
      formData.append("address", this.address);
      formData.append("postalCode", this.postalCode);
      formData.append("province", this.province);
      _axios
        .post(config.identity.authority + "/register", formData, {
          onUploadProgress: (progressEvent) => {
            console.log(progressEvent.loaded / progressEvent.total);
          },
        })
        .then((response) => {
          this.$router.push("callback?msg=" + response.data);
        })
        .catch((err) => {
          if (
            err.response &&
            err.response.status &&
            err.response.status == "400"
          )
            this.ErrorNotifications(err.response.data);
          else
            this.Notify("please check that you have data or your internet connection is on");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
 ErrorNotifications(obj) {
      let errorNotification = "";
      for (let prop in obj) {
        errorNotification += obj[prop].description + "\n";
      }
      this.Notify(errorNotification);
    },
    Notify(message) {
      this.$bvToast.toast(message, {
        title: "Notification",
        variant: "danger",
        autoHideDelay: 5000,
      });
    }
  },
};
</script>
<style>
</style>
